import '@/util/doNotUseInWorker';

import { commonTranslatorConfig, type AppDict, type AppProvidedArgs, type FlatAppDict } from '@/translations/commonTranslatorConfig';
import meta from '@/translations/languages/generated/meta.json';
import { configureTranslations } from '@whiz-cart/ui-shared/translate';
import orderBy from 'lodash/orderBy';
import { createTranslator, type ReactCreateTranslatorResult } from 'schummar-translate/react';

const dicts: Record<string, () => Promise<Partial<FlatAppDict>>> = Object.fromEntries(
    Object.entries(import.meta.glob('./languages/generated/*.ts', { import: 'default' })).map(([key, value]) => {
        const locale = key.match(/([^/]*)\.ts$/)![1]!;

        return [locale, async () => value() as Promise<Partial<FlatAppDict>>];
    }),
);

export const { t, useTranslator, useGetTranslator, TranslationContextProvider, getTranslator } = createTranslator({
    ...commonTranslatorConfig,
    dicts,
}) as ReactCreateTranslatorResult<AppDict, FlatAppDict, AppProvidedArgs>;

// @ts-expect-error incompatible types
configureTranslations({ t, useTranslator });

const AdditionalProperties: { [code: string]: { region?: string } } = {
    de: { region: 'DE' },
    en: { region: 'US' },
    'en-CA': {},
    'fr-CA': {},
    fr: { region: 'FR' },
    nb: { region: 'NO' },
    ro: { region: 'RO' },
    th: { region: 'TH' },
};

export const LanguageMeta = {
    ...meta,
    languages: orderBy(
        meta.languages.map((language) => {
            const code = [language.language, language.region].filter(Boolean).join('-');
            return {
                code,
                ...language,
                ...AdditionalProperties[code],
            };
        }),
        (language) => {
            const index = Object.keys(AdditionalProperties).indexOf(language.code);
            return index >= 0 ? index : Infinity;
        },
    ),
};

export const browserLocale = dicts[navigator.language] ? navigator.language : navigator.language.slice(0, 2);
